import { oauthButtonHandler } from './oauth-utils';

/* Event listener for unlocking an article with Google */
async function unlockContentWithGoogle(response) {
  const googleBtn = document.querySelector('div[data-callback="unlockContentWithGoogle"]');
  const optInCheckboxParent = googleBtn.closest(
    '.read-this-article-immersive, .read-this-article, #immersive-article-modal'
  );
  const optInCheckbox = optInCheckboxParent && optInCheckboxParent.querySelector('.opt-in');
  const shareGuid = googleBtn.dataset.shareGuid;
  await oauthButtonHandler({
    idToken: response.credential,
    verificationUri: googleBtn.attributes['data-redirect-uri'].value, // A rails route helper is attached to the button's data-redirect-uri attribute
    verificationExtras: {
      article_id: currentPage.articleId,
      briefing_guid: currentPage.briefingGuid, // a user can unlock an article or a briefing
      declined_opt_in: optInCheckbox ? optInCheckbox.checked == false : false,
      opt_in_required: !!optInCheckbox,
      provider: 'google',
      share_guid: shareGuid,
    },
  });
}

/* Event listener for logging in with Google */
async function logInWithGoogle(response) {
  const googleBtn = document.querySelector('div[data-callback="logInWithGoogle"]');
  await oauthButtonHandler({
    idToken: response.credential,
    verificationUri: googleBtn.attributes['data-redirect-uri'].value,
    verificationExtras: {
      returning_url: googleBtn.attributes['data-returning-uri'].value,
      provider: 'google',
    },
  });
}

/* Event listener for lead sign-up with Google */
async function createLeadWithGoogle(response) {
  const googleBtn = document.querySelector('div[data-callback="createLeadWithGoogle"]');
  const optInCheckboxParent = googleBtn.closest(
    '.locked, .read-this-article-immersive, .read-this-article, #immersive-article-modal, .ti-static, .newsletter-landing, #newsletters'
  );
  const optInCheckbox = optInCheckboxParent && optInCheckboxParent.querySelector('.opt-in');
  const leadType = googleBtn.dataset.leadType;
  const formLocation = googleBtn.dataset.formLocation;
  const page = googleBtn.dataset.page;
  const returningUri = googleBtn.dataset.returningUri;
  await oauthButtonHandler({
    idToken: response.credential,
    verificationUri: googleBtn.attributes['data-redirect-uri'].value,
    verificationExtras: {
      declined_opt_in: optInCheckbox ? optInCheckbox.checked == false : false,
      lead_type: leadType,
      form_location: formLocation,
      page: page,
      opt_in_required: !!optInCheckbox,
      returning_uri: returningUri,
      provider: 'google',
    },
  });
}

export { logInWithGoogle, createLeadWithGoogle, unlockContentWithGoogle };
